import { useSeekaConverge } from "@seeka-labs/converge-react";
import { Box, Flex, PrimaryButton, LegacyText } from "flicket-ui";
import { Select } from "~components";
import { useSeatedReservationStore } from "~features/seated-reservation/store";
import * as actions from "~features/seated-reservation/store/actions/index";
import { useIsMobile } from "~hooks";

type OptionsProps = {
  handleClose: () => void;
  seatAmountOptions: any;
};

export const Options = ({ handleClose, seatAmountOptions }: OptionsProps) => {
  const converge = useSeekaConverge();
  const isMobile = useIsMobile();

  const chartReady = useSeatedReservationStore((state) => state.chartReady);
  const options = useSeatedReservationStore((state) => state.options);

  const updateOptions = async (key, value) =>
    actions.updateOptions({ options: { [key]: value } }, converge);

  return (
    <Flex flexDir="column" width="100%" p={{ _: 2, md: 0 }}>
      <Box>
        <LegacyText fontWeight="extraBold" color="N800" fontSize={2} mb="6/4">
          I need tickets for
        </LegacyText>
        <Select
          value={seatAmountOptions.find(
            (option) => option.value === options.amount
          )}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          onChange={async ({ value }) => updateOptions("amount", value)}
          options={seatAmountOptions}
          mb={5}
          isDisabled={!chartReady}
          selectProps={{
            isSearchable: false,
            // 300 is the default max menu height
            // This fixes a bug on android Chrome
            // where the dropdown does off the bottom viewport
            maxMenuHeight: isMobile ? 150 : 300,
          }}
        />
      </Box>

      <PrimaryButton mt={3} mb={5} onClick={handleClose} width="100%">
        Select seat{options.amount > 1 ? "s" : ""}
      </PrimaryButton>
    </Flex>
  );
};
